<template>
  <div class="error-page page">
    <LayoutsError>
      <h2 class="error-page__title">
        Error {{ attrs.error.statusCode }}: {{ attrs.error.message }}
      </h2>
    </LayoutsError>
  </div>
</template>

<script setup>
import { onMounted, useAttrs } from 'vue'
import { useTracking } from './composables/useTracking'
import { loadScripts } from '~/utils/scripts'

const attrs = useAttrs()

loadScripts()

console.warn(attrs.error)

onMounted(() => {
  //  track the error page
  useTracking({ title: 'Error', collection: 'error', slug: 'error' })
})
</script>

<style scoped lang="postcss">
.error-page {
  overflow: hidden;

  &__title {
    visibility: visible;
    color: var(--color-blue-aqua);
  }
}
</style>
